import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function VideocamOffIcon(props: IconProps) {
    return <Icon {...props} iconKey={"videocam_off"}/>
}
